var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { decryptFileWithDecipherStream } from '../../CryptoUtils';
import { asyncFetch } from '../../NetworkUtils';
const PopupContainer = styled.div `
  position: relative;
  z-index: 50;
  min-width: 400px;
  max-width: 80vh;
  max-height: 80vh;
  outline: none;
  overflow: hidden;
  @media (max-width: 1024px) {
    min-width: 200px;
    max-height: 50vh;
  }
`;
const OverlayContainer = styled.div `
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 40;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    height: 100vh;
  }
`;
const FullScreenImage = styled.img `
  @media (min-width: 1025px) {
    max-width: 100%;
    max-height: calc(75vh - 56px);
    object-fit: contain;
  }
  @media (max-width: 1024px) {
    max-width: 100%;
    max-height: 40vh;
    object-fit: scale-down;
  }
`;
const TopBar = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 200px;
  margin-bottom: 0.5rem;
`;
const TitleLink = styled.a `
  color: #4e95ff;
  text-decoration: none;
  cursor: pointer;
  :hover {
    color: #74abff;
    text-decoration: underline;
  }
  font-family: Helvetica Neue;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
`;
const CloseButton = styled.div `
  color: #fff;
  fill: #fff;
  position: relative;
  top: 0;
  right: 0;
  &:hover {
    color: #5765f2;
    fill: #5765f2;
  }
  cursor: pointer;
`;
const popupContainerStyle = {
    backgroundColor: '#1d1d21',
    padding: '16px',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};
const MessageImageField = ({ images, encryptionKey, nonce, authToken, privateIpfsEndpoint }) => {
    if (!images || (images === null || images === void 0 ? void 0 : images.length) === 0)
        return null;
    const mainImage = images[0];
    const [fullScreenOpen, setFullScreenOpen] = useState(false);
    const [dataUrl, setDecryptedFile] = useState();
    useEffect(() => {
        var _a;
        const encrypted = (_a = mainImage.ipfs_cid) === null || _a === void 0 ? void 0 : _a.startsWith('encrypted_');
        if (encrypted) {
            const cid = mainImage.ipfs_cid.slice('encrypted_'.length);
            asyncFetch(`${privateIpfsEndpoint}/${cid}`, {
                method: 'GET',
                headers: Object.assign({}, (authToken ? { 'x-api-key': authToken } : {})),
            }).then((res) => __awaiter(void 0, void 0, void 0, function* () {
                var _b;
                if (res.status === 500) {
                    setDecryptedFile(undefined);
                    return;
                }
                else {
                    const extension = (_b = mainImage.name) === null || _b === void 0 ? void 0 : _b.split('.').pop();
                    let blob = yield decryptFileWithDecipherStream(encryptionKey, nonce, res.body);
                    blob = new Blob([blob], { type: `image/${extension}` });
                    const objectUrl = URL.createObjectURL(blob);
                    setDecryptedFile(objectUrl);
                }
            }));
        }
        else {
            setDecryptedFile(mainImage.ipfs_cid);
        }
        // Clean up the URL when the component is unmounted
        return () => {
            if (dataUrl) {
                URL.revokeObjectURL(dataUrl);
            }
        };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("img", { src: dataUrl, alt: "uploaded", onClick: () => setFullScreenOpen(true), style: {
                    height: '300px',
                    width: '300px',
                    maxHeight: '300px',
                    maxWidth: '300px',
                    objectFit: 'contain',
                    marginLeft: '40px',
                    paddingTop: '8px',
                    borderRadius: '4px',
                    objectPosition: 'left',
                } }), fullScreenOpen && (_jsx(OverlayContainer, Object.assign({ onClick: () => setFullScreenOpen(false) }, { children: _jsxs(PopupContainer, Object.assign({ style: popupContainerStyle }, { children: [_jsxs(TopBar, { children: [_jsx(TitleLink, Object.assign({ href: dataUrl, target: "_blank" }, { children: mainImage.name })), _jsx(CloseButton, Object.assign({ onClick: () => setFullScreenOpen(false) }, { children: _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", className: "bi bi-x-lg", viewBox: "0 0 16 16" }, { children: _jsx("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" }) })) }))] }), _jsx(FullScreenImage, { src: dataUrl, alt: "A meaningful description" })] })) })))] }));
};
export default MessageImageField;
